import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConnectSftpPage = lazy(() => import('~/features/onboarding/pages/connect-sftp-screen'));

/** `connectionId` present → edit the subsidiary's SFTP connection; absent → create. */
const searchSchema = z.object({
  connectionId: z.string().optional(),
});

function ConnectSftpRouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectSftpPage platform="meta" connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute('/_authenticated/_tenant/onboarding/integration/meta/sftp')({
  validateSearch: searchSchema,
  component: ConnectSftpRouteComponent,
});
